export default "__VITE_ASSET__Cp$zJZOrZ7vW50FYmc4KJg__"